<template>
  <div v-if="isVisible" class="absolute top-full left-0 right-0 z-50 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
    <div class="p-2">
      <div v-if="isLoading" class="flex items-center justify-center py-4">
        <i class="fas fa-spinner fa-spin text-purple-500 mr-2"></i>
        <span class="text-sm text-gray-600">Searching...</span>
      </div>
      <div v-else-if="results.length > 0">
        <div class="text-xs text-gray-500 mb-2 px-2">
          {{ results.length }} result{{ results.length !== 1 ? 's' : '' }} found
        </div>
        <div
          v-for="(result, index) in results"
          :key="index"
          @click="selectResult(result)"
          @mouseenter="handleMouseEnter(index)"
          class="px-3 py-2 hover:bg-gray-100 cursor-pointer rounded-md transition-colors"
          :class="{ 'bg-purple-50 border-l-4 border-purple-500': selectedIndex === index }"
        >
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <div class="font-medium text-gray-900">{{ result.league }}</div>
              <div class="text-sm text-gray-600">{{ result.season }} - {{ result.league_id }}</div>
            </div>
            <div class="text-xs text-gray-500">
              {{ result.data_type }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="px-3 py-4 text-center text-gray-500">
        <i class="fas fa-search text-lg mb-2"></i>
        <div class="text-sm">No results found</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false
  },
  results: {
    type: Array,
    default: () => []
  },
  selectedIndex: {
    type: Number,
    default: -1
  },
  isLoading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['select-result', 'update:selectedIndex'])

const selectResult = (result) => {
  emit('select-result', result)
}

const handleMouseEnter = (index) => {
  emit('update:selectedIndex', index)
}
</script>

<style scoped>
/* Custom scrollbar for the results list */
.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
